import { GrupoDespesa, RetAPI, error99, grupoDespesaAttributes } from '../../Utils/Types'
import { Api } from '../../Utils/api'
import { v4 as uuid } from 'uuid'
import { encode as base64_encode } from 'base-64'

export const GrupoDespesaService = {

    GetAttributes: async (id?: string): Promise<RetAPI> => {

        const resp = await Api('GrupoDespesa/attributes', 'get', { id })
        const attributes: grupoDespesaAttributes = {
            subGrupoDespesa: [],
            grupoDespesa: {
                id: 0,
                id_sgrupo_despesa: 0,
                description: '',
                classificacao: '',
                id_user_insert: 0,
                id_user_last_update: 0,
                dt_cadastro: '',
                dt_last_update: '',
                name_user_insert: '',
                name_user_last_update: '',
            }

        }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: attributes
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.sgdespesas) {
                    resp.data.sgdespesas.map((item: any) => {
                        attributes.subGrupoDespesa.push({
                            id: item.id,
                            description: item.descricao,
                            id_empresa: item.id_empresa,
                            dt_cadastro: item.dt_cadastro,
                            id_user_insert: item.id_user_insert,
                            dt_last_update: item.dt_last_update,
                            id_user_last_update: item.id_user_last_update,
                            name_user_insert: item.name_user_insert

                        })
                    })
                }

                if (resp.data.grupo_despesa) {

                    attributes.grupoDespesa.id = resp.data.grupo_despesa.id
                    attributes.grupoDespesa.id_sgrupo_despesa = resp.data.grupo_despesa.id_sgrupo_despesa
                    attributes.grupoDespesa.description = resp.data.grupo_despesa.descricao
                    attributes.grupoDespesa.classificacao = resp.data.grupo_despesa.classificacao
                    attributes.grupoDespesa.id_user_insert = resp.data.grupo_despesa.id_user_insert
                    attributes.grupoDespesa.id_user_last_update = resp.data.grupo_despesa.id_user_last_update
                    attributes.grupoDespesa.dt_cadastro = resp.data.grupo_despesa.dt_cadastro
                    attributes.grupoDespesa.dt_last_update = resp.data.grupo_despesa.dt_last_update
                    attributes.grupoDespesa.name_user_insert = resp.data.grupo_despesa.name_user_insert
                    attributes.grupoDespesa.name_user_last_update = resp.data.grupo_despesa.name_user_last_update

                }
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: attributes
            }
        }

        return {
            error: false,
            data: attributes
        }

    },

    Save: async (grupoDespesa: any): Promise<RetAPI> => {

        let id = ''

        if (grupoDespesa.id) {
            id = grupoDespesa.id.toString()
        }

        const resp = await Api('GrupoDespesa/save', 'post', {

            descricao: grupoDespesa.description,
            id_sgrupo_despesa: grupoDespesa.id_sgrupo_despesa,
            classificacao: grupoDespesa.classificacao,
            id

        })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    field: resp.data.field

                }
            }

            return {
                error: false,
                msg: 'Dados do grupo de despesa gravados com sucesso',
                id: resp.data.grupo_despesa.id,
                data: resp.data,
                dt_cadastro: resp.data.grupo_despesa.dt_cadastro,
                dt_last_update: resp.data.grupo_despesa.dt_last_update,
                name_user_insert: resp.data.grupo_despesa.name_user_insert,
                name_user_last_update: resp.data.grupo_despesa.name_user_last_update
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    Delete: async (idExcluir: number, motivo: string, senha: string): Promise<RetAPI> => {

        const random = uuid()

        senha = base64_encode(senha + '-' + random)

        const resp = await Api(`GrupoDespesa/delete?id=${idExcluir}&motivo=${motivo}&senha=${senha}`, 'delete')

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            msg: '',
        }

    },

    Filter: async (field: string, filter_type: string, filter: string, id?: string): Promise<RetAPI> => {

        const resp = await Api('GrupoDespesa/filter', 'get', { field, filter_type, filter, id })
        const grupoDespesa: GrupoDespesa[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: grupoDespesa
                }
            }

            if (resp.data.error && resp.data.error === '0') {
                resp.data.grupo_despesa.map((item: any) => {
                    return grupoDespesa.push({

                        id: item.id,
                        id_sgrupo_despesa: item.id_sgrupo_despesa,
                        description: item.descricao,
                        desc_sgrupo: item.desc_sgrupo,
                        classificacao: item.classificacao,
                        dt_cadastro: item.dt_cadastro,

                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: grupoDespesa
            }
        }

        return {
            error: false,
            data: grupoDespesa
        }
    },

    Relatorio: async (datai: string, dataf: string, descricao?: string, mostrar_excluidas?: string): Promise<RetAPI> => {

        const resp = await Api('GrupoDespesa/Report/relatorio', 'get', { datai, dataf, descricao, mostrar_excluidas })
        const grupoDesp: any[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: grupoDesp
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.grupo_despesa.map((item: any) => {
                    return grupoDesp.push({

                        id: item.id,
                        id_user_exclusao: item.id_user_exclusao,
                        dh_exclusao: item.dh_exclusao,
                        motivo_exclusao: item.motivo_exclusao,
                        name_user_delete: item.name_user_delete,
                        descricao: item.descricao,

                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: grupoDesp
            }
        }

        return {
            error: false,
            data: grupoDesp,
        }

    }
}
